import { gql } from 'graphql-tag';

export default gql`
  query GetTrackTransaction($purchase_id: Int!) {
    getTrackTransaction(purchase_id: $purchase_id) {
      id
      fee
      subtotal
      total
      original_total
      refund
      discount
      credit
      purchase_date
      status
      show_fee
      user {
        id
        name
        first_name
        last_name
        formatted_name
        email
        cellphone
      }
      users {
        promo
        user {
          id
          name
          first_name
          last_name
        }
        tickets {
          id
          name
          price
          refunded
          credited
          type
          barcode
          section
          row
          seat
          date
          scan_logs {
            type
            status
            created_at
            scanner {
              first_name
              last_name
            }
          }
        }
      }
      international_fee
      order_source
      payment_method
      delivery_method
      register
      credits_issued
      refunded_amount
      event {
        id
        name
        start_date
        end_date
      }
      track {
        id
        name
      }
      account {
        id
        business_dba
      }
    }
  }
`;
